import OfferPartnershipLabel from 'components/Common/Labels/OfferPartnershipLabel'
import ImageCarousel from 'components/Luxkit/Carousel/ImageCarousel'
import { mediaQueryUp } from 'components/utils/breakpoint'
import useImpressionHandler from 'hooks/useImpressionHandler'
import moment from 'moment'
import { rem } from 'polished'
import React, { useMemo } from 'react'
import styled from 'styled-components'
import SearchTilePriceDetails from '../TileSections/SearchTilePriceDetails'
import { Main, OfferOverlayContainer, StyledOfferBadge, StyledCSSBreakpoint, DetailSegment } from '../SearchTileStyles'
import SearchRentalPropertyDetails from './SearchVillaPropertyDetails'
import TripGuard from 'tripPlanner/components/TripGuard/TripGuard'
import BookmarkButton from 'tripPlanner/components/Bookmark/BookmarkButton'
import FloatingBookmarkContainer from 'tripPlanner/components/Bookmark/Common/FloatingBookmarkContainer'
import OffsetBookmarkContainer from 'tripPlanner/components/Bookmark/Common/OffsetBookmarkContainer'
import useSearchSplitView from 'components/SearchV2/Hooks/useSearchSplitView'
import cn from 'clsx'

interface Props {
  offer: App.VillaOffer;
  bestPriceForDates?: App.OfferAvailableRate;
  filters?: App.OfferListFilters;
  offerUrl: string;
  bestPricePackage?: App.Package;
}

const MainImageSegment = styled.div`
  position: relative;
  height: 100%;
  min-height: ${rem(240)};

  ${mediaQueryUp.tablet} {
    min-height: 0%;
  }
`

function SearchVillaTileExpanded(props: Props) {
  const {
    offer,
    bestPriceForDates,
    filters,
    offerUrl,
    bestPricePackage,
  } = props

  const { locationHeading, locationSubheading, badge, images: offerImages } = offer
  const images = offerImages
  const location = useMemo(() => [locationHeading, locationSubheading].filter(t => t).join(', '), [locationHeading, locationSubheading])
  const impressionRef = useImpressionHandler(offer.id)
  const cancellationPolicyType = offer.lowestPricePackage?.roomRate?.cancellationPolicy.type

  const showSplitView = useSearchSplitView()

  return (
    <Main ref={impressionRef}>
      <MainImageSegment>
        <ImageCarousel
          images={images}
        />
        <OfferOverlayContainer>
          <OfferPartnershipLabel offer={offer} variant="icon" />
        </OfferOverlayContainer>
        {badge && <StyledOfferBadge badge={badge} dimensions={{ width: 86, height: 86 }} />}
      </MainImageSegment>
      <div>
        <DetailSegment className={cn({ splitView: showSplitView })}>
          <TripGuard>
            <StyledCSSBreakpoint min="tablet">
              <FloatingBookmarkContainer>
                <BookmarkButton offer={offer} />
              </FloatingBookmarkContainer>
            </StyledCSSBreakpoint>
            <StyledCSSBreakpoint max="mobile">
              <OffsetBookmarkContainer>
                <BookmarkButton offer={offer} />
              </OffsetBookmarkContainer>
            </StyledCSSBreakpoint>
          </TripGuard>
          <SearchRentalPropertyDetails
            offer={offer}
            location={location}
            cancellationPolicyType={cancellationPolicyType}
            filters={filters}
            offerUrl={offerUrl}
          />
          <SearchTilePriceDetails
            offer={offer}
            filters={filters}
            soldOut={false}
            offerUrl={offerUrl}
            bestPriceForDates={bestPriceForDates}
            bestPricePackage={bestPricePackage}
            checkInDate={moment(filters?.checkIn)}
            />
        </DetailSegment>
      </div>
    </Main>
  )
}

export default SearchVillaTileExpanded
